/*eslint-disable*/
import { Autocomplete } from '@mui/material';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import { useEffect, useState } from 'react';
import translating from '../../../translate.json';

const AutocompleteComp = ({ field, Controller, control }) => {
  const [currentField, setCurrentField] = useState();

  useEffect(() => {
    let cf = JSON.parse(JSON.stringify(field));
    if (!cf.options) cf.options = [];

    if (!find(cf.options, { id: 'all' }))
      cf.options?.push({
        id: 'all',
        [field.searchBy]: translating.all
      });
    cf.options.reverse();
    setCurrentField(cf);
  }, []);

  return (
    <>
      {currentField && (
        <FormControl
          variant="standard"
          sx={{ m: 1, minWidth: 120 }}
          className="filter-input autocomplete"
          classes={{ root: 'formControlRoot' }}
        >
          <Controller
            name={field.name}
            control={control}
            //
            render={({ field: { onChange } }) => (
              <Autocomplete
                key={field.name}
                {...field}
                onChange={(e, value) => {
                  onChange(value.id);
                }}
                defaultValue={currentField.options[0]}
                className="filterInput"
                classes={{ select: 'selectInput' }}
                data-testid="test-select"
                label="Auto Complete"
                options={currentField?.options}
                getOptionLabel={(option) =>
                  field?.searchBy ? option[field?.searchBy] : option.name
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={field.label}
                    placeholder={field.label}
                  />
                )}
              />
            )}
          />
        </FormControl>
      )}
    </>
  );
};

export default AutocompleteComp;

AutocompleteComp.propTypes = {
  field: PropTypes.object,
  Controller: PropTypes.any,
  control: PropTypes.any
};
